import { ReportDefinitions, RoleReportInput } from 'generated/graphql-types';
import { UserReportViewModel } from './user-report-permission.model';

export interface RoleReportViewModel {
   roleId: number;
   roleReportId: number;
   reportId: ReportDefinitions;
}

export interface RoleReportItemView {
   roleReportId: number;
   roleId: number;
   reportId: ReportDefinitions;
   isDeleted: boolean;
}

export const roleReportsFields: (keyof RoleReportInput)[] = ['reportId', 'roleId'];

export function reportPermissionsSort(
   a: RoleReportViewModel | UserReportViewModel,
   b: RoleReportViewModel | UserReportViewModel
): number {
   if ((a.reportId ?? 0) > (b.reportId ?? 0)) {
      return 1;
   }
   if ((a.reportId ?? 0) < (b.reportId ?? 0)) {
      return -1;
   }
   return 0;
}
